









import { defineComponent, ref } from '@vue/composition-api';

import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';
import useSSOLogin from '@/renderer/components/login/compositions/useSSOLogin';
import tips from '@/renderer/scripts/utils/tips';
import store from '@/renderer/store';
import { i18n_t } from '@/locales/i18n';

export default defineComponent({
  components: {
    AgreementCheckbox,
  },
  setup(props, context) {
    const agreementRef = ref<AgreementComponent | null>(null);
    const IOABtnLoading = ref(true);
    const { corpId, methods: ssoMethods } = useSSOLogin();

    const methods = {
      async loginWithIOA() {
        if (!agreementRef.value?.validate()) {
          return;
        }
        if (!corpId.value) {
          tips.error(i18n_t('请联系运维管理员 echoyydeng,inkiewu,fysntian 处理'));
          return;
        }
        ssoMethods.openSSOUrl();
      },
      validate() {
        return agreementRef.value?.validate();
      },
    };
    store.dispatch('getCorpList').then(() => {
      IOABtnLoading.value = false;
      ssoMethods.initList({ noCache: true });
    });

    return {
      IOABtnLoading,
      agreementRef,
      ...methods,
    };
  },
});
